import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "@/utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/exam",
    name: "Exam",
    component: () => import("../views/Exam.vue")
  },
  {
    path: "/lookExam",
    name: "LookExam",
    component: () => import("../views/LookExam.vue")
  },
  {
    path: "/mobileLookExam",
    name: "MobileLookExam",
    component: () => import("../views/MobileLookExam.vue")
  },
  {
    path: "/",
    name: "ExamIndex",
    redirect: "/curExam",
    component: () => import("@/views/ExamIndex.vue"),
    children: [
      {
        path: "/curExam",
        name: "CurExam",
        component: () => import("@/views/CurExam")
      },
      {
        path: "/scoreQuery",
        name: "ScoreQuery",
        component: () => import("@/views/ScoreQuery")
      },
      {
        path: "/profile",
        name: "Profile",
        component: () => import("@/views/Profile.vue")
      }
    ]
  },
  {
    path: "/examNeedToKnow",
    name: "ExamNeedToKnow",
    component: () => import("@/views/ExamNeedToKnow.vue")
  },
  {
    path: "/backCameraQrcode",
    name: "BackCameraQrcode",
    component: () => import("@/views/BackCameraQrcode.vue")
  },
  {
    path: "/frontCameraPush",
    name: "FrontCameraPush",
    component: () => import("@/views/FrontCameraPush.vue")
  },
  {
    path: "/confirmProfile",
    name: "ConfirmProfile",
    component: () => import("@/views/ConfirmProfile.vue")
  },
  {
    path: "/examCatalog",
    name: "ExamCatalog",
    component: () => import("@/views/ExamCatalog.vue")
  },
  {
    path: "/resetPassword",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword")
  },
  {
    path: "/examCatalog",
    name: "ExamCatalog",
    component: () => import("@/views/ExamCatalog")
  },
  {
    path: "/examConfirm",
    name: "ExamConfirm",
    component: () => import("@/views/ExamConfirm")
  },
  {
    path: "/checkVideo",
    name: "CheckVideo",
    component: () => import("@/views/checkVideo")
  },
  {
    path: "/checkVideo2",
    name: "CheckVideo2",
    component: () => import("@/views/checkVideo2")
  },
  {
    path: "/**",
    redirect: "/"
  }
];

const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  //如果跳转的页面不存在，跳转到404页面
  if (to.matched.length === 0) {
    next("/404");
  }
  if (getToken()) {
    next();
  } else {
    if (to.path === "/login") {
      next();
    } else if (to.path === "/lookExam") {
      next();
    } else if (to.path === "/mobileLookExam") {
      next();
    } else if (to.path === "/resetPassword") {
      next();
    } else {
      next("/login");
    }
  }
});
export default router;
